import React from 'react'
import { Field } from 'formik'

import * as S from './styled'

const SearchEnginePreview = ({ path }) => {
    const articleCategoryLink = slug =>
        `${process.env.REACT_APP_STOREFRONT_URL || window.location.origin}/${path}/${slug ||
            'article-path'}`

    return (
        <S.SearchEnginePreview>
            <S.SearchEngineUrl data-testid="seo-path">
                <Field name="path">{({ field }) => <>{articleCategoryLink(field.value)}</>}</Field>
            </S.SearchEngineUrl>
            <Field name="path">
                {({ field }) => (
                    <S.SearchEngineTitle
                        href={articleCategoryLink(field.value)}
                        target="_blank"
                        data-testid="seo-title"
                    >
                        <Field name="title">
                            {({ field, form }) => {
                                if (field?.value?.length) {
                                    return field.value
                                } else {
                                    return form?.values?.title ? form.values.title : 'Article Title'
                                }
                            }}
                        </Field>
                    </S.SearchEngineTitle>
                )}
            </Field>

            <S.SearchEngineDescription data-testid="seo-description">
                <Field name="metaDescription">
                    {({ field, form }) => {
                        if (field?.value?.length) {
                            return field.value
                        } else {
                            return (
                                <i>
                                    You have no description set. Descriptions are important and can
                                    influence click-through rates. The optimal length is between
                                    50–160 characters.
                                </i>
                            )
                        }
                    }}
                </Field>
            </S.SearchEngineDescription>
        </S.SearchEnginePreview>
    )
}

export default SearchEnginePreview
